import { get, isEmpty, isNil, keys } from 'lodash-es';

import { fetchDataByAsset } from './fetchDataByAsset';
import { aiDashboardAssets, aiCohortsMap } from '../configs/constants';
import api from '../api';

const { getCancelToken } = api.buildRequestCancelation();

// AI App Trends
// Response transformers
const aiAppTrendsTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  const staticMetrics = 'average_time_spent_per_dau';

  const timeSeries = get(data, [staticMetrics], {});
  const cohortsDistribution = get(data, ['cohorts_distribution'], {});

  const reducedTimeSeries = keys(timeSeries).reduce(
    (acc, cohort) => ({
      ...acc,
      [cohort]: get(timeSeries, [cohort, staticMetrics], []),
    }),
    {}
  );

  const cohortsTimeSeries = keys(cohortsDistribution).reduce(
    (acc, cohort) => ({
      ...acc,
      [cohort]: get(cohortsDistribution, [cohort, 'mau_v2_segment_share_percentile'], []).map(
        ([timestamp, value]) => [timestamp, isNil(value) ? null : value * 100]
      ),
    }),
    {}
  );

  return {
    data: {
      time_series: reducedTimeSeries || {},
      cohort_distribution_series: cohortsTimeSeries || {},
    },
  };
};

// Request
export const fetchAiAppTrends =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.aiAppTrends];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.aiAppTrends, requestFilters, {
        cancelToken: getCancelToken('aiAppTrends').token,
        transformResponse: (data) => aiAppTrendsTransformResponse(data),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };

// Segment Transitions
// Response transformers
const segmentTransitionsTransformResponse = (data) => {
  if (isEmpty(data)) return { data: {} };

  const chartData = get(data, ['table_data'], {});

  const cohortOrder = keys(aiCohortsMap);

  const formattedChartData = !!chartData && cohortOrder
    .reduce(
      (acc, cohort) => [
        ...acc,
        ...(chartData[cohort] ? cohortOrder.map(
          (nextCohort) => [
            aiCohortsMap[cohort],
            `End-${aiCohortsMap[nextCohort]}`,
            get(chartData, [cohort, nextCohort], null),
          ]
        ) : []),
      ], []
    ) || [];

  return {
    data: {
      table_data: chartData,
      chart_series: formattedChartData,
    },
  };
};

// Request
export const fetchSegmentTransitions =
  (nextFilters = {}) =>
  (dispatch, getState) => {
    const { aiDashboard } = getState();
    const { filters } = aiDashboard[aiDashboardAssets.segmentTransitions];

    const requestFilters = {
      ...filters,
      ...nextFilters,
    };

    dispatch(
      fetchDataByAsset(aiDashboardAssets.segmentTransitions, requestFilters, {
        cancelToken: getCancelToken('segmentTransitions').token,
        transformResponse: (data) => segmentTransitionsTransformResponse(data),
        decorateRequestAction: (action) => ({
          ...action,
          filters: requestFilters,
        }),
      })
    );
  };
